import React, { useEffect, useState } from "react";
import {
  PlaceholderColumnas,
  PlaceholderTabla,
} from "../../components/Otros/Placeholder";
import { ListaNoPrecalificados } from "../../components/PreCalificacion/ListaNoPrecalificados";
import { InformacionProcesoParticipacion } from "../../components/ProcesosDeCalificacion/InformacionProcesoParticipacion";
import { cargarProcesoActivo } from "../../utils/Datos";
import { UrlWs } from "../../utils/Global";
import { ReportePrecalificadores } from "../../components/Reportes/ReportePrecalificadores";
import { Cargando } from "../../components/Otros/Cargando";
import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";

async function cargar(idProcess) {
  const url =UrlWs+ "/process/" + idProcess;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export const ListarPorPrecalificador = () => {
  const [procesoActivo, setProcesoActivo] = useState(null);
  const [datosProceso, setDatosProceso] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const precalificador = 12; //variable de Bryan, ni idea que hace.
  const user = useSelector(selectUser);

  console.table(user);

  useEffect(() => {
    if (procesoActivo != null && cargandoDatos === false) {
      setCargandoDatos(true);
      cargar(procesoActivo.id_process).then((datos) => {
        setCargandoDatos(false);
        setDatosProceso(datos);
      });
    }
  }, [procesoActivo]);

  useEffect(() => {
    cargarProcesoActivo().then((datos) => {
      setProcesoActivo(datos);
    });
  }, []);

  return (
    <>
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div className="toolbar" id="kt_toolbar">
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
                Precalificar
              </h1>
              <span className="h-20px border-gray-300 border-start mx-4" />
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-300 w-5px h-2px" />
                </li>
                <li className="breadcrumb-item text-dark">
                  Buscar Proceso de Calificación
                </li>
              </ul>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
          </div>
        </div>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                         INFORMACIÓN DEL PROCESO ACTIVO
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    {datosProceso == null ? (
                      <PlaceholderColumnas columnas={3}></PlaceholderColumnas>
                    ) : (
                      <InformacionProcesoParticipacion
                        key="-editar_proceso"
                        proceso={datosProceso}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="col-xl-12 ">
                <div className="card ">
                  <div className="card-header ">
                    <h3 className="card-title align-items-start flex-column ">
                      <span className="card-label fw-bolder text-dark ">
                         FUNCIONARIO/A A PRECALIFICAR
                      </span>
                    </h3>
                  </div>
                  <div className="card-body ">
                    <div className="table-responsive">
                      {procesoActivo != null ? (
                        <ListaNoPrecalificados
                          idProcess={procesoActivo.id_process}
                          precalificador={precalificador}
                        ></ListaNoPrecalificados>
                      ) : (
                        <PlaceholderTabla></PlaceholderTabla>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                          <h3 className="card-title align-items-start flex-column">
                          <span className="card-label fw-bolder text-dark">
                              Reporte de Precalificadores
                          </span>
                          </h3>
                  </div>
                  <div className="card-body">
                      {
                        datosProceso!=null && user!=null ?
                        <ReportePrecalificadores 
                        officer_id={user.user.id_officer}
                        id_process={datosProceso.id_process}/> :
                        <Cargando />
                      }
                      
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
